import React, { Component } from 'react';
import { withLocalize, Translate } from "react-localize-redux";
import PropTypes from 'prop-types';
import SvgRefresh from "../../img/icons/Refresh";
import "./refreshComponent.scss"
import BbCheckbox from '../styling/bbCheckbox';

class RefreshComponent extends Component {
    static propTypes = {
        autoRefresh: PropTypes.bool,
        onAutoRefresh: PropTypes.func,
        onRefresh: PropTypes.func
    };

    render() {
        return (
            <div className="refresh-component" style={this.props.style || null}>
                <SvgRefresh className="icon-refresh" onClick={() => this.props.onRefresh()} />
                <BbCheckbox
                    id="auto-refresh"
                    value={this.props.autoRefresh}
                    onChange={(value) => this.props.onAutoRefresh(value)}
                    label={this.props.translate('Search.Cee.AutoRefresh')}
                />
            </div>
        )
    }
}

export default withLocalize(RefreshComponent);
